import {Injectable} from "@angular/core";
import {MasterProvider} from "../../../utility/MasterProvider";
import {Injector} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../../utility/auth-service";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


@Injectable()

export class SidebarProvider extends MasterProvider
{
    
    API_GET_MODULE:string="/api/AdModule/getModuleLst"    /////Get List Of Modules 
    API_GET_MODULE_PAGE:string="/api/AdPage/getAdPageLst"    /////Get List Of Pages of Each Modules 
     DEMO_API:string="/api/AdRolePage/getPages"
    
    public save(obj: any) {
    }
    public update(obj: any) {
    }
    public findById(objId: any) {
    }
    public findAll() {
    }
    public deleteById(obj: any) {
    }
    public defunctById(obj: any) {
    }
    constructor(public injector: Injector, public http: HttpClient,public authService:AuthService)
    {
        super(injector, http,authService);
    }
    
    getPages(data)
    {
        console.log(data);
        return this.doHttpGet(this.DEMO_API,true,data);
    }
    
}